import { executeRequest, JFSRequest } from '@jfs/network'
import { isSuccessResponse } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  return isSuccessResponse(response)
}

const getRequest = (data: any) => {
  return {
    approvalId: data.id,
    approvalType: data.type,
    status: data.status,
  }
}

const packageProcessApprovals = (data: any, tokens: any, filetype?: number) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.routingProcessApproval),
    method: 'POST',
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: {
      ...getRequest(data),
      fileType: filetype
    },
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { packageProcessApprovals }
